import store from "store";

export function getAPIUrl(includeProtocol = true): {
	api: string;
	api2: string;
} {
	const isDevEnvironment =
		window.location.hostname.startsWith("dev.") ||
		window.location.hostname === "localhost";
	const isProductionVersion = import.meta.env.PROD;
	if (store.get("local_dev", false)) {
		return {
			api: `${includeProtocol ? "http://" : ""}localhost:3000/api`,
			api2: `${includeProtocol ? "http://" : ""}localhost:3000/api2`,
		};
	}
	if (isProductionVersion) {
		if (isDevEnvironment) {
			return {
				api: `${includeProtocol ? "https://" : ""}api.dev.kultifyapp.com`,
				api2: `${includeProtocol ? "https://" : ""}api2.dev.kultifyapp.com`,
			};
		}
		return {
			api: `${includeProtocol ? "https://" : ""}api.kultifyapp.com`,
			api2: `${includeProtocol ? "https://" : ""}api2.kultifyapp.com`,
		};
	}
	return {
		api: `${includeProtocol ? "https://" : ""}api.dev.kultifyapp.com`,
		api2: `${includeProtocol ? "https://" : ""}api2.dev.kultifyapp.com`,
	};
}
